import { Stack } from "@mui/material";
import { type FC } from "react";
import { useMemo } from "react";

import { CategoryChip, TagChip } from "~/components/UI/CategoryChip";
import { LIST_CHIP_HEIGHT } from "~/components/UI/CategoryChip/CategoryChip.styles";
import { PlatformIcons } from "~/components/UI/PlatformIcons";
import type { Platform } from "~/types/platform";
import { type EventTagValue, isEventTagValue } from "~/types/tag";

interface IEventTagsProps {
  tags?: string[];
  categoryId: string;
  platforms?: Platform[];
}

export const EventTags: FC<IEventTagsProps> = ({
  tags,
  categoryId,
  platforms = [],
}) => {
  const filteredTags = useMemo(
    () => tags?.filter((item): item is EventTagValue => isEventTagValue(item)),
    [tags]
  );

  return (
    <Stack
      direction="row"
      spacing={0.5}
      sx={{
        alignItems: "center",
        flexWrap: "wrap"
      }}>
      {filteredTags?.map((tag) => (
        <TagChip key={tag} tag={tag} />
      ))}
      {categoryId && <CategoryChip categoryId={categoryId} />}
      {platforms.length > 0 && (
        <PlatformIcons platforms={platforms} size={LIST_CHIP_HEIGHT} />
      )}
    </Stack>
  );
};
